<template>
  <div> <!-- Wrapping both elements in a parent div -->
    <div class="limiter" v-if="id">
      <div class="image">
        <img src="../assets/logo/logo.png" alt="Logo">
      </div>

      <div class="container-login100">
        <div class="wrap-login100">
          <div class="form-summary">
            <h2 style="color: #3A6898">Payment Details</h2>
            <div class="form-group">
              <p class="summary-item"><strong>Payment:</strong> {{ payment }}</p>
            </div>
            <div class="form-group">
              <p class="summary-item"><strong>SaleTotal:</strong> {{ saletotal }}</p>
            </div>
          </div>
          <form class="login100-form validate-form">
            <div class="form-group">
              <label for="amount">Enter Amount</label>
              <input v-model.number="paymentTotal" id="amount" class="input100" type="number" name="amount" placeholder="Enter amount" required>
            </div>
          </form>
          <span><strong>Note:</strong> The remaining amount is due upon completion of installation</span>
        </div>
      </div>

      <h3>Select Payment Method</h3>
      <div class="payment-methods">
        <button type="button" class="login100-form-btn btn-file-input" @click="attach" ref="scrollToBottom">
          <img src="../assets/img/bank.png" alt="Bank Icon" class="button-icon" /> Bank / EFT
        </button>
        <button type="button" class="login100-form-btn btn-file-input" @click="payByKazang">
          <img src="../assets/img/Kazang.png" alt="Mobile Money Icon" class="button-icon" /> Mobile Money
        </button>
      </div>

      <div class="buttons">
        <div class="payment-option">
          <span class="payment-label">Takes 2 Days to Process</span>
          <div class="file-input-container">
            <!-- Intentionally left blank -->
          </div>
        </div>

        <div class="payment-option" v-if="!file">
          <span class="payment-label">Instant Payment</span>
        </div>
      </div>
    </div>

    <!-- The card section for attachment -->
    <div class="card" v-if="showattach">
      <div class="card-body">
        <div class="text-center mb-3">
          <h5>Payment Reference: {{ paymentReference }}</h5>
          <button class="btn btn-sm btn-secondary" @click="copyReference">
            Copy Reference
          </button>
        </div>

        <span>
          <span v-html="message"></span>
          <br><br>
          Note : We would like to remind you that when making a manuel payment, it is very
          important
          to use the
          correct reference.
          This ensures that your payment is correctly applied to your account and prevents any
          delays in
          processing.
          Please make sure to double check the reference number before making your manuel
          payment.
          Thank you for choosing our manuel payment option and if you have any questions or
          concerns,
          please do
          not hesitate to reach out to us.
        </span>
      </div>

      <div class="buttons">
        <div class="payment-option">
          <span v-if="!file" class="payment-label">Takes 2 Days to Process</span>
          <span v-if="file" class="payment-label" @click="preview" style="cursor: pointer;"><strong>Click to Preview</strong></span>
          <div class="file-input-container mb-2">
            <input
                id="file-pacraCert"
                class="input100"
                type="file"
                name="pop"
                @change="handleFileChange($event)"
                accept=".pdf,image/*"
            >
            <label for="file-pacraCert" class="btn-file-input">{{ pop || 'Attach proof of payment' }}</label>
          </div>
          <!-- Conditionally render the Submit button only if a file is selected -->
          <button v-if="file" class="login100-form-btn submit-btn" @click="submit">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div> <!-- End of wrapping root element -->
</template>


<script>
export default {
  name: 'PaymentDetails',
  data() {
    return {
      file: null,
      id: this.$route.query.id,
      payment: 'Deposit',
      minimumDeposit: '',
      saletotal: '',
      amountToPay: 0,
      pop: '',
      message:'',
      paymentReference:'',
      showattach: false,
      paymentTotal: 0,
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
  },
  methods: {
    async preview() {
      try {
        const fileBase64 = this.file ? await this.fileToBase64(this.file) : '';
        const fileType = this.file ? this.file.type : ''; // Check file type (e.g., 'image/png', 'application/pdf')

        const newWindow = window.open('', '_blank');
        if (!newWindow) {
          throw new Error('Failed to open new window. It might be blocked by the browser.');
        }

        if (fileType.startsWith('image/')) {
          // Handle image preview
          newWindow.document.write(`
        <html>
            <head><title>Image Preview</title></head>
            <body style="text-align: center; padding: 20px;">
                <h1>Image Preview</h1>
                <img src="${fileBase64}" style="max-width: 100%; height: auto;" />
            </body>
        </html>
      `);
        } else if (fileType === 'application/pdf') {
          // Handle PDF preview
          newWindow.document.write(`
        <html>
            <head><title>PDF Preview</title></head>
            <body style="text-align: center; padding: 20px;">
                <h1>PDF Preview</h1>
                <embed src="${fileBase64}" type="application/pdf" width="100%" height="600px" />
            </body>
        </html>
      `);
        } else {
          throw new Error('Unsupported file type for preview.');
        }

        newWindow.document.close();
      } catch (error) {
        console.error('Error previewing file:', error.message);
      }
    },
    async fetchData() {
      this.$store.commit(`setLoadingState`,true)
      return this.$store.dispatch('fetchDebtor',this.id)
          .then((data) => {
            this.saletotal = data.quoteTotal;
            this.minimumDeposit = data.minimumDeposit ;
            this.message = data.message.replaceAll("\n","<br>");
            this.paymentReference = data.paymentReference;
            this.paymentTotal = data.minimumDeposit;
          })
          .finally(()=> this.$store.commit(`setLoadingState`,false))
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.file = file;
        this.pop = file.name; // Display the file name
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    async submit() {
      const fileBase64 = this.file ? await this.fileToBase64(this.file) : '';
      let id = this.$route.query.id;

      const payload = {
        amount: this.paymentTotal,
        Payment_ID: id,
        FileName: this.pop,
        type: 'QUOTE',
        File: fileBase64,
      };
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('popValidation',payload)
        .then(()=> {
          responses.showSuccess(`Your information has been submitted!`)
          this.showattach = false;
          return window.open("/success",`_self`);
        })
        .finally(()=> this.$store.commit('setLoadingState', false))
    },

    async payByKazang(){
      let ref = {
        quoteNumber: this.id,
        amount:this.amountToPay,
        discountAmount:this.saletotal - this.amountToPay
      }
      let encodedRef = window.btoa(JSON.stringify(ref));
      const payload = {
        amount:   this.saletotal,
        Service_Description: `Payment on quote: ${this.id}`,
        Client_Refrence: encodedRef,
        Cancel_Url: 'https://zero.chrilantech.com/test-failed',
        Sucess_Url: 'https://synergy.abc.co.zm/success',
      }
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('createTransaction', payload)
          .finally(()=>  this.$store.commit('setLoadingState', false))

    },

    async attach() {
      this.showattach = true;
      this.$nextTick(() => {
        if (this.$refs.scrollToBottom) {
          this.$refs.scrollToBottom.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },

    async copyReference(){
      copy(this.paymentReference)
      responses.showSuccess(`Reference copied`)
    },
    handleClick(type) {
      if (type === 'bank') {
        this.$router.push({ path: '/bank-payment', query: { id: this.id } });
      } else if (type === 'mobile') {
        this.$router.push({ path: '/mobile-payment', query: { id: this.id } });
      }
    },

  }
}
</script>

<style scoped>
.buttons {
  flex-wrap: wrap; /* Allows items to wrap onto multiple lines */
  max-width: 600px; /* Adjusted to give more space for items */
  margin: 30px auto; /* Center the container horizontally */
  display: flex;
  justify-content: space-between; /* Space items evenly */
  align-items: center; /* Center items vertically */
  gap: 30px; /* Increased space between payment options */
}

.payment-option {
  display: flex;
  flex-direction: column; /* Stack the label and button/file input vertically */
  align-items: center; /* Center items horizontally */
}

.payment-label {
  font-size: 0.875rem; /* Smaller font size for labels */
  margin-bottom: 15px; /* Increased space between label and button/file input */
}

.file-input-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center file input and label */
}

.input100 {
  min-width: 200px;
  display: none; /* Hide the actual file input */
}

.payment-methods {
  display: flex;
  gap: 10px; /* Adds space between the buttons */
  justify-content: center; /* Centers the buttons horizontally */
}

/* Consolidated button style */
.btn-common {
  min-width: 200px; /* Uniform width */
  padding: 12px 20px; /* Increased padding for better appearance */
  background-color: #3A6898; /* Primary button background color */
  color: white; /* Button text color */
  border: none; /* Remove default button border */
  border-radius: 5px; /* Make buttons slightly rounded */
  cursor: pointer; /* Pointer cursor for clickable buttons */
  transition: background-color 0.3s ease; /* Smooth hover transition */
  text-align: center;
  display: flex;
  align-items: center; /* Align content within the button */
  justify-content: center;
  gap: 10px; /* Gap between text and icons */
}

.btn-common:hover {
  background-color: #2c507a; /* Darker background color on hover */
}

.login100-form-btn, .btn-file-input, .submit-btn {
  composes: btn-common; /* Apply common button styles */
}

/* Icon-specific styles */
.button-icon {
  width: 20px; /* Adjust the size of the icons */
  height: 20px;
}

h3 {
  text-align: center; /* Centers the text horizontally */
  margin-top: 20px; /* Add some space above if necessary */
  margin-bottom: 20px; /* Add some space below if necessary */
  font-size: 1.5rem; /* Adjust the font size as needed */
  font-weight: bold; /* Optional: makes the text bold */
  color: #3A6898; /* Optional: Change the color if desired */
}

</style>


